module.exports = __webpack_public_path__ + "static/assets/aa743407aebd7813fc3911bcc4b75e62.svg";